module.exports = __webpack_public_path__ + "static/img/logo1.516bfdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo1.jpg
// module id = bn24
// module chunks = 19